var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarBlank = function SvgCalendarBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.938 2.5H9.625V1.078A.35.35 0 0 0 9.297.75H8.203a.33.33 0 0 0-.328.328V2.5h-3.5V1.078A.35.35 0 0 0 4.047.75H2.953a.33.33 0 0 0-.328.328V2.5H1.313C.574 2.5 0 3.102 0 3.813v9.625c0 .738.574 1.312 1.313 1.312h9.625c.71 0 1.312-.574 1.312-1.312V3.813A1.33 1.33 0 0 0 10.938 2.5m-.165 10.938H1.477q-.165 0-.165-.165V5.125h9.626v8.148c0 .11-.083.165-.165.165"
  })));
};
export default SvgCalendarBlank;